import script from "./DisputeReasonModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DisputeReasonModal.vue?vue&type=script&setup=true&lang=js"

import "./DisputeReasonModal.vue?vue&type=style&index=0&id=8f808662&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f808662"]])

export default __exports__